import { Spinner } from '@apex/component-library'
import { Box, VStack } from '@chakra-ui/react'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useTransferSearch } from '../../hooks'
import { MessageCenter } from '../MessageCenter'
import { LayoutContext } from '../../containers/contexts/layout/LayoutContext'
import { TransferResultsTable, TransferSearchBar } from './index'
import styles from './styles.module.less'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { AcatsSearchDto } from '../../api/types'
import { has, isEqual, startsWith } from 'lodash'
import { AcatsTransfer } from '../../api/types'

const TransferSearchPage = ({
  history,
  location: { search, state: locationState },
}: RouteComponentProps) => {
  const {
    transferSearchState: {
      transferResults,
      errorMessage,
      loadingResults,
      acatsSearchDto,
    },
    searchTransfers,
  } = useTransferSearch()
  const { headerHeight, footerHeight } = useContext(LayoutContext)
  const [tableDimensions, setTableDimensions] = useState({
    height: 0,
    width: 0,
  })
  const transferSearchBarRef = useRef<HTMLDivElement>(null)
  useState(() => {
    if (startsWith(search, '?q=')) {
      const acatsTransferFilters: AcatsSearchDto = {}
      const queryParams = search.substring('?q='.length).split('&')
      queryParams.forEach(pair => {
        const nameValue = pair.split('=')
        // @ts-ignore
        acatsTransferFilters[nameValue[0]] = decodeURIComponent(nameValue[1])
      })
      if (!isEqual(acatsSearchDto, acatsTransferFilters)) {
        searchTransfers(history, acatsTransferFilters)
      }
    } else if (has(locationState, 'acatsTransferFilters')) {
      searchTransfers(
        history,
        (locationState as { acatsTransferFilters: AcatsSearchDto })
          .acatsTransferFilters
      )
    } else {
      searchTransfers(history, {})
    }
  })

  const searchBarHeight = transferSearchBarRef.current?.clientHeight || 0

  useEffect(() => {
    const recalcTableDimensions = () => {
      setTableDimensions({
        height:
          window.innerHeight - headerHeight - footerHeight - searchBarHeight,
        width: window.innerWidth,
      })
    }
    recalcTableDimensions()
    window.addEventListener('resize', recalcTableDimensions)

    return () => {
      window.removeEventListener('resize', recalcTableDimensions)
    }
  }, [headerHeight, footerHeight, searchBarHeight])

  const cleanedTransferResults: AcatsTransfer[] = transferResults.map(
    transfer => ({
      ...transfer,
      totalAccountValue: transfer.totalAccountValue
        ? transfer.totalAccountValue
        : 'pending',
    })
  )

  console.log('cleaned Results', cleanedTransferResults)

  return (
    <VStack spacing={0} flex="1 1 auto" align="stretch">
      <Box ref={transferSearchBarRef}>
        <TransferSearchBar />
      </Box>
      {loadingResults ? (
        <VStack justifyContent="center" flex="1 1 auto">
          <Spinner size="lg" />
        </VStack>
      ) : errorMessage ? (
        <Box className={styles.messageBanner}>
          <MessageCenter errorMessages={[errorMessage]} />
        </Box>
      ) : (
        <VStack flex="1 1 auto" align="start">
          <TransferResultsTable
            transferResults={cleanedTransferResults}
            height={tableDimensions.height}
            width={tableDimensions.width}
            acatsSearchDto={acatsSearchDto}
          />
        </VStack>
      )}
    </VStack>
  )
}

export default withRouter(TransferSearchPage)
